<div class="home-container" [class.few-trains]="(trainData.data?.length || 0) < 20" [style.--rows]="boardRowCount">
  @if(hasDataError) {
    <div class="data-error-banner">Kunde inte hämta tågdata — försöker igen...</div>
  }
  <div class="train-container">
    @if(trainData && trainData.data) {

      <table class="table-left">
        <thead id="header-container" class="header-font">
          <tr>
            <td class="col-announced">Tågnr</td>
            <td class="col-otn">OTN</td>
            <td class="show-border-left">Station</td>
            <td class="show-border-left">Tid</td>
          </tr>
        </thead>
        @for(data of northboundTrains; track trackTrain(data)) {
          <tbody>
            <tr [ngClass]="customRowCss(data)">
              <td class="col-announced train-cell show-border-top hover-underline"
                [matTooltip]="getTrainTooltipText(data.direction)"
                [matTooltipPosition]="getTooltipPosition()"
                [matTooltipShowDelay]="isMobileSize ? 0 : 500"
                matTooltipTouchGestures="on">
                {{ data.announcedTrainNumber }}{{ data.suffix }}
              </td>
              <td
                class="col-otn train-cell show-border-top hover-underline"
                [matTooltip]="getTrainTooltipText(data.direction)"
                [matTooltipPosition]="getTooltipPosition()"
                [matTooltipShowDelay]="isMobileSize ? 0 : 500"
                matTooltipTouchGestures="on">
                {{ data.trainNumber }}{{ data.suffix }}
              </td>
              <td class="train-cell show-border-top show-border-left text-uppercase hover-underline"
                [class.arrived]="data.currentLocationStatus === CurrentLocationStatus.ARRIVED"
                [matTooltip]="getFullLocationNameWithArrival(data)"
                [matTooltipPosition]="getTooltipPosition()"
                [matTooltipShowDelay]="isMobileSize ? 0 : 500"
                matTooltipTouchGestures="on">
                {{ data.location }}
              </td>
              @if (getTrainInfo(data); as trainInfo) {
                <td class="show-border-top show-border-left time-cell hover-underline"
                  [matTooltip]="trainInfo.tooltipText"
                            [ngClass]="{
                                'train-tablerow--service-white': data.trainType === TrainType.SERVICETRAIN && data.delay < 3,
                                'train-tablerow--standard': data.trainType !== TrainType.SERVICETRAIN && data.delay < 3,
                                'train-tablerow--delay-red': data.delay >= 3
                            }"
                  [matTooltipPosition]="getTooltipPosition()"
                  [matTooltipShowDelay]="isMobileSize ? 0 : 500"
                  matTooltipTouchGestures="on">
                  {{ trainInfo.displayText }}
                </td>
              }
            </tr>
          </tbody>
          } @empty {
          <div>No trains found...</div>
        }
      </table>

      <div class="middle-item mt-4" id="percentage-container">
        @if(trainData) {
          <div class="train-percentage">{{ trainData.trainOnTimePercentage != null ? trainData.trainOnTimePercentage + '%' : '-' }}</div>
          <div class="train-percentage-text">Tåg i tid</div>
          <div class="train-updatetime">Uppdaterad:<br>{{ timeOfUpdate }}</div>
        }
      </div>

      <table class="table-right">
        <thead class="header-font">
          <tr>
            <td class="col-announced">Tågnr</td>
            <td class="col-otn">OTN</td>
            <td class="show-border-left">Station</td>
            <td class="show-border-left">Tid</td>
          </tr>
        </thead>
        @for(data of southboundTrains; track trackTrain(data)) {
          <tbody>
            <tr [ngClass]="customRowCss(data)">
              <td class="col-announced train-cell show-border-top hover-underline"
                [matTooltip]="getTrainTooltipText(data.direction)"
                [matTooltipPosition]="getTooltipPosition()"
                [matTooltipShowDelay]="isMobileSize ? 0 : 500"
                matTooltipTouchGestures="on">
                {{ data.announcedTrainNumber }}{{ data.suffix }}
              </td>
              <td
                class="col-otn train-cell show-border-top hover-underline"
                [matTooltip]="getTrainTooltipText(data.direction)"
                [matTooltipPosition]="getTooltipPosition()"
                [matTooltipShowDelay]="isMobileSize ? 0 : 500"
                matTooltipTouchGestures="on">
                {{ data.trainNumber }}{{ data.suffix }}
              </td>
              <td class="train-cell show-border-top show-border-left text-uppercase hover-underline"
                [class.arrived]="data.currentLocationStatus === CurrentLocationStatus.ARRIVED"
                [matTooltip]="getFullLocationNameWithArrival(data)"
                [matTooltipPosition]="getTooltipPosition()"
                [matTooltipShowDelay]="isMobileSize ? 0 : 500"
                matTooltipTouchGestures="on">
                {{ data.location }}
              </td>
              @if (getTrainInfo(data); as trainInfo) {
                <td class="show-border-top show-border-left time-cell hover-underline"
                  [matTooltip]="trainInfo.tooltipText"
                            [ngClass]="{
                                'train-tablerow--service-white': data.trainType === TrainType.SERVICETRAIN && data.delay < 3,
                                'train-tablerow--standard': data.trainType !== TrainType.SERVICETRAIN && data.delay < 3,
                                'train-tablerow--delay-red': data.delay >= 3
                            }"
                  [matTooltipPosition]="getTooltipPosition()"
                  [matTooltipShowDelay]="isMobileSize ? 0 : 500"
                  matTooltipTouchGestures="on">
                  {{ trainInfo.displayText }}
                </td>
              }
            </tr>
          </tbody>
          } @empty {
          <div>No trains found...</div>
        }
      </table>

    } @else if(trainData && !isFetchingTrainData && !hasDataError) {
      <div class="no-trains-container">
        <div class="no-trains-message">{{ trainData.status || 'Inga aktiva tåg' }}</div>
      </div>
    }

  </div>

  @if(messageData.length > 0) {
    <div class="message-container">
      @for(message of messageData; track message.id) {
        <div class="message-content">
          <span class="message-body"
            [class.disabled]="!isInIframe"
            [attr.aria-disabled]="!isInIframe"
            [style.pointer-events]="!isInIframe ? 'none' : 'auto'"
            (click)="isInIframe && openMessage(message)">
            {{ message.body }}
          </span>
        </div>
      }
    </div>
  }
</div>
